import type { ToolbarCounts } from '#/shared/api/generated/shipment/models'
import { useGetCountsApiV1ToolbarCountsGet } from '#/shared/api/generated/shipment/theCargoShipment'

export interface UseShipmentToolbarCountsResult {
  counts: ToolbarCounts | undefined
  isLoading: boolean
}

export function useShipmentToolbarCounts(
  shipmentId: string | undefined,
): UseShipmentToolbarCountsResult {
  const enabled = Boolean(shipmentId)
  const query = useGetCountsApiV1ToolbarCountsGet(
    { shipment_id: shipmentId ?? '' },
    { query: { enabled } },
  )

  return {
    counts: query.data?.data,
    isLoading: query.isLoading && enabled,
  }
}

const COUNT_KEYS = [
  'note',
  'task',
  'file',
  'contract',
  'sms',
  'email',
  'payment',
  'activity',
] as const

export function sumToolbarCounts(counts: ToolbarCounts | undefined): number {
  if (!counts) return 0
  return COUNT_KEYS.reduce((total, key) => total + counts[key], 0)
}
